<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/oZP5Wb/images/Cover.jpg?1696332729264" alt="This image is the cover for the book Know Your Station, Know Your Station"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Know Your Station, Know Your Station
      </h1>
      <p class="bookDescription body article font2">
        <p>The wealthiest people in the solar system abandoned the Earth for a sanctuary in space, leaving the poor to die from climate change. But the 1% won’t be safe for long… because a murderer is on the loose, with the rich as their target! Soon Elise, an employee on the billionaires’ space station, is wrapped up in a deadly investigation, dragged deeper into the conspiracy as the last body she wants to go missing does. Even worse, her withdrawals from a highly addictive substance are getting worse and causing terrible hallucinations. But those drug-induced delusions are nothing compared to the gut-wrenchingly grisly discoveries at the heart of this deadly whodunnit… Bestselling novelist Sarah Gailey (Eat the Rich, Just Like Home) and rising artistic star Liana Kangas (TRVE KVLT) take a stab at the ultra-wealthy, their dreams of escaping the planet they’ve put in peril, and the consequences of that economic terror in the near future… Collects Know Your Station #1-5.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sarah Gailey, Liana Kangas
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      BOOM! Studios
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7b6c08f2